import { addDoc, collection, deleteDoc, doc, getDocs, orderBy, query, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

export const CONTENT_TYPES = {
  proofs: 'paymentProofs',
  reviews: 'userReviews',
  videos: 'workVideos',
  salaries: 'salaryList'
};

export const loadPublicContent = async (type) => {
  const collectionName = CONTENT_TYPES[type];
  if (!collectionName) return [];

  try {
    const snapshot = await getDocs(query(collection(db, collectionName), orderBy('createdAt', 'desc')));
    return snapshot.docs.map((item) => ({ id: item.id, ...item.data() }));
  } catch (error) {
    return [];
  }
};

export const createPublicContent = async (type, payload) => {
  const collectionName = CONTENT_TYPES[type];
  if (!collectionName) throw new Error('Unknown content type.');

  const result = await addDoc(collection(db, collectionName), {
    ...payload,
    createdAt: serverTimestamp()
  });
  return { id: result.id, ...payload };
};

export const removePublicContent = async (type, id) => {
  const collectionName = CONTENT_TYPES[type];
  if (!collectionName || !id) throw new Error('Invalid content item.');
  await deleteDoc(doc(db, collectionName, id));
};

export const uploadImageToImgBB = async (file, apiKey) => {
  if (!file) throw new Error('একটি ছবি নির্বাচন করুন।');
  if (!apiKey.trim()) throw new Error('আগে ImgBB API key সেট করুন।');

  const body = new FormData();
  body.append('image', file);
  const response = await fetch(`https://api.imgbb.com/1/upload?key=${encodeURIComponent(apiKey.trim())}`, {
    method: 'POST',
    body
  });
  const result = await response.json();

  if (!response.ok || !result.success || !result.data?.display_url) {
    throw new Error(result.error?.message || 'ImgBB-তে ছবি upload করা যায়নি।');
  }

  return result.data.display_url;
};

export const getVideoEmbed = (url) => {
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.replace(/^www\./, '');
    if (host === 'youtu.be') {
      const id = parsed.pathname.slice(1);
      return id ? `https://www.youtube-nocookie.com/embed/${id}` : '';
    }
    if (host === 'youtube.com' || host === 'm.youtube.com') {
      const id = parsed.searchParams.get('v') || parsed.pathname.match(/\/(?:embed|shorts)\/([^/]+)/)?.[1];
      return id ? `https://www.youtube-nocookie.com/embed/${id}` : '';
    }
    if (host === 'vimeo.com') {
      const id = parsed.pathname.split('/').filter(Boolean)[0];
      return id ? `https://player.vimeo.com/video/${id}` : '';
    }
    return '';
  } catch (error) {
    return '';
  }
};

export const isDirectVideoUrl = (url) => /\.(mp4|webm|ogg)(?:[?#].*)?$/i.test(url || '');
